<template>
  <div v-show="show">
    <el-form :inline="true" class="style1">
      <el-form-item>
        <el-button class="el-icon-circle-plus-outline" type="text" @click="dialogVisible = true">{{$t("general.add")}}
        </el-button>
      </el-form-item>
    </el-form>

    <el-table :data="tableData" stripe highlight-current-row border style="width: 100%"
      :empty-text="$t('general.empty_data')">

      <el-table-column :label="$t('companyInfo.name')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.name1 }}</span>
          <span>{{ scope.row.name2 }}</span>
          <span>{{ scope.row.name3 }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('healthIns1.agent')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.agent }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('healthIns1.labor_ins_name')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.labor_ins_name }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('healthIns1.health_ins_name')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.healthInsName }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('general.operation')" align="center" fixed="right" width="350">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)">
            {{$t("general.edit")}}</el-button>
          <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleDelete(scope.$index, scope.row)">
            {{$t("general.delete")}}</el-button>
          <el-button size="mini" type="success" icon="el-icon-success" @click="printPDF(scope.$index, scope.row)">
            {{$t("general.print")}}</el-button>
          <!-- <el-button size="mini" type="success" icon="el-icon-view" @click="preview(scope.$index, scope.row)" plain>
          </el-button> -->
        </template>
      </el-table-column>
    </el-table>

    <!--adding new-->
    <el-dialog :title="$t('general.add')" :append-to-body="true" :visible.sync="dialogVisible" width="69%"
      :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="200px" class="demo-ruleForm" size="medium"
        :label-position="labelPosition">
        <el-input type="hidden" v-model="ruleForm.id" />

        <el-collapse>
          <el-collapse-item :title="$t('healthIns1.general_info')" name="1" style="margin-left:10px">
            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('companyInfo.name')+':'" prop="name1" style="margin-left:50px">
                    <el-select v-model="ruleForm.name1" clearable style="margin-left:10px;width: 185px" size="mini"
                      :empty-text="$t('general.empty_data')" :placeholder="$t('general.please_select')">
                      <el-option v-for="item in companyInfo" :key="item.id" :label="item.name1" :value="item.name1">
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns1.health_ins_name')" prop="healthInsName" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.healthInsName" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns1.health_ins_name')"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns1.welfare_pension_no')" prop="welfare_pension_no"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.welfare_pension_no" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns1.welfare_pension_no')">
                    </el-input>
                  </el-form-item>
                  <el-form-item :label="$t('healthIns1.labor_ins_name')" prop="labor_ins_name" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.labor_ins_name" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns1.labor_ins_name')"></el-input>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="12">
                <div>
                  <el-form-item><br></el-form-item>
                  <el-form-item :label="$t('healthIns1.health_ins_name_pho')" prop="healthInsName_kn"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.healthInsName_kn" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns1.health_ins_name_pho')">
                    </el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns1.welfare_pension_name')" prop="welfare_pension_name"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.welfare_pension_name" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns1.welfare_pension_name')">
                    </el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>

          <el-collapse-item :title="$t('healthIns1.allowrance')" name="2" style="margin-left:10px">
            <el-row>
              <el-col :span="22">
                <div>
                  <el-form-item>
                    <el-checkbox v-model="ruleForm.allowrance1" size="mini">{{$t("healthIns1.food")}}</el-checkbox>
                    <el-checkbox v-model="ruleForm.allowrance2" size="mini">{{$t("healthIns1.housing")}}</el-checkbox>
                    <el-checkbox v-model="ruleForm.allowrance3" size="mini">{{$t("healthIns1.clothing")}}</el-checkbox>
                    <el-checkbox v-model="ruleForm.allowrance4" size="mini">{{$t("healthIns1.commuter_pass")}}
                    </el-checkbox>
                    <el-checkbox v-model="ruleForm.allowrance5" size="mini">{{$t("healthIns1.other")}}</el-checkbox>
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.other_allowrance" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns1.other')"
                      v-if="ruleForm.allowrance5 === true"></el-input>
                    <el-button class="el-icon-info" type="text" @click="otherAllowranceHint"
                      v-if="ruleForm.allowrance5 === true"></el-button>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="10">
                <div>
                  <el-form-item :label="$t('healthIns1.allowrance1st')" prop="allowrance_schedule1"
                    style="margin-left:50px">
                    <el-select v-model="ruleForm.allowrance_schedule1" :placeholder="$t('general.select')" size="mini"
                      style="margin-left:10px;width: 150px" clearable>
                      <el-option v-for="item in month" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns1.allowrance3rd')" prop="allowrance_schedule3"
                    style="margin-left:50px">
                    <el-select v-model="ruleForm.allowrance_schedule3" :placeholder="$t('general.select')" size="mini"
                      style="margin-left:10px;width: 150px" clearable>
                      <el-option v-for="item in month" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="10">
                <div>
                  <el-form-item :label="$t('healthIns1.allowrance2nd')" prop="allowrance_schedule2"
                    style="margin-left:50px">
                    <el-select v-model="ruleForm.allowrance_schedule2" :placeholder="$t('general.select')" size="mini"
                      style="margin-left:10px;width: 150px" clearable>
                      <el-option v-for="item in month" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns1.allowrance4th')" prop="allowrance_schedule4"
                    style="margin-left:50px">
                    <el-select v-model="ruleForm.allowrance_schedule4" :placeholder="$t('general.select')" size="mini"
                      style="margin-left:10px;width: 150px" clearable>
                      <el-option v-for="item in month" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>
          <el-collapse-item :title="$t('healthIns1.bonus')" name="3" style="margin-left:10px">
            <el-row>
              <el-col :span="10">
                <div>
                  <el-form-item :label="$t('healthIns1.first')" prop="bonus_schedule1" style="margin-left:50px">
                    <el-select v-model="ruleForm.bonus_schedule1" :placeholder="$t('general.select')" size="mini"
                      style="margin-left:10px;width: 150px" clearable>
                      <el-option v-for="item in month" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('healthIns1.third')" prop="bonus_schedule3" style="margin-left:50px">
                    <el-select v-model="ruleForm.bonus_schedule3" :placeholder="$t('general.select')" size="mini"
                      style="margin-left:10px;width: 150px" clearable>
                      <el-option v-for="item in month" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="10">
                <div>
                  <el-form-item :label="$t('healthIns1.second')" prop="bonus_schedule2" style="margin-left:50px">
                    <el-select v-model="ruleForm.bonus_schedule2" :placeholder="$t('general.select')" size="mini"
                      style="margin-left:10px;width: 150px" clearable>
                      <el-option v-for="item in month" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('healthIns1.fourth')" prop="bonus_schedule4" style="margin-left:50px">
                    <el-select v-model="ruleForm.bonus_schedule4" :placeholder="$t('general.select')" size="mini"
                      style="margin-left:10px;width: 150px" clearable>
                      <el-option v-for="item in month" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>
          <el-collapse-item :title="$t('healthIns1.agent')" name="4" style="margin-left:10px">
            <el-row>
              <el-col :span="10">
                <div>
                  <el-form-item :label="$t('healthIns1.agent')" style="margin-left:50px">
                    <el-select v-model="ruleForm.agent" :placeholder="$t('general.select')" size="mini"
                      style="margin-left:10px;width: 100px">
                      <el-option v-for="item in agent" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row v-if="ruleForm.agent === '有'">
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('healthIns1.agent_name')" prop="agent_name" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.agent_name" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns1.agent_name')"></el-input>
                    <el-button class="el-icon-info" type="text" @click="agentHint"></el-button>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('healthIns1.agent_address')" prop="agent_address" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.agent_address" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns1.agent_address')"></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>

          <el-collapse-item :title="$t('healthIns1.category')" name="5" style="margin-left:10px">
            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('healthIns1.category')" style="margin-left:50px">
                    <el-select v-model="ruleForm.div1" :placeholder="$t('general.select')" clearable size="mini"
                      style="margin-left:10px;width: 185px">
                      <el-option v-for="item in div1" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                    <el-button class="el-icon-info" type="text" @click="div1Hint" v-if="ruleForm.div1 === '個人'">
                    </el-button>
                  </el-form-item>
                  <el-form-item :label="$t('healthIns1.office_category')" v-if="ruleForm.div1 !== '個人'"
                    style="margin-left:50px">
                    <el-select v-model="ruleForm.div3" :placeholder="$t('general.select')" clearable size="mini"
                      style="margin-left:10px;width: 185px">
                      <el-option v-for="item in div3" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('healthIns1.no_category')" v-if="ruleForm.div1 !== '個人'"
                    style="margin-left:50px">
                    <el-select v-model="ruleForm.div2" :placeholder="$t('general.select')" clearable size="mini"
                      style="margin-left:10px;width: 185px">
                      <el-option v-for="item in div2" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns1.country_category')" v-if="ruleForm.div1 !== '個人'"
                    style="margin-left:50px">
                    <el-select v-model="ruleForm.div4" :placeholder="$t('general.select')" clearable size="mini"
                      style="margin-left:10px;width: 185px">
                      <el-option v-for="item in div4" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>
        </el-collapse>
        <el-row>
          <div>
            <br />
            <el-form-item :label="$t('healthIns1.remark')" prop="remark" style="margin-left:50px">
              <el-input prefix-icon="el-icon-edit" v-model="ruleForm.remark" size="mini"
                style="margin-left:10px;width: 300px" :placeholder="$t('healthIns1.remark')"></el-input>
            </el-form-item>
          </div>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button style="width:120px" @click="addUser('ruleForm')" type="primary" size="medium">
          {{$t("general.confirm")}}
        </el-button>
        <el-button style="width:120px" @click="s1_cancel('ruleForm')" size="medium">{{$t("general.cancel")}}</el-button>
      </span>
    </el-dialog>

    <!--edit data-->
    <el-dialog :title="$t('general.edit')" :append-to-body="true" :visible.sync="dialogUpdate" width="69%"
      :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="200px" class="demo-ruleForm" size="medium"
        :label-position="labelPosition">

        <el-input type="hidden" v-model="ruleForm.id" />

        <el-collapse>
          <el-collapse-item :title="$t('healthIns1.general_info')" name="1" style="margin-left:10px">
            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('companyInfo.name')+':'" prop="name1" style="margin-left:50px">
                    <el-select v-model="ruleForm.name1" clearable style="margin-left:10px;width: 185px" size="mini"
                      :empty-text="$t('general.empty_data')" :placeholder="$t('general.please_select')">
                      <el-option v-for="item in companyInfo" :key="item.id" :label="item.name1" :value="item.name1">
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns1.health_ins_name')" prop="healthInsName" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.healthInsName" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns1.health_ins_name')"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns1.welfare_pension_no')" prop="welfare_pension_no"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.welfare_pension_no" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns1.welfare_pension_no')">
                    </el-input>
                  </el-form-item>
                  <el-form-item :label="$t('healthIns1.labor_ins_name')" prop="labor_ins_name" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.labor_ins_name" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns1.labor_ins_name')"></el-input>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="12">
                <div>
                  <el-form-item><br></el-form-item>
                  <el-form-item :label="$t('healthIns1.health_ins_name_pho')" prop="healthInsName_kn"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.healthInsName_kn" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns1.health_ins_name_pho')">
                    </el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns1.welfare_pension_name')" prop="welfare_pension_name"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.welfare_pension_name" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns1.welfare_pension_name')">
                    </el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>

          <el-collapse-item :title="$t('healthIns1.allowrance')" name="2" style="margin-left:10px">
            <el-row>
              <el-col :span="22">
                <div>
                  <el-form-item>
                    <el-checkbox v-model="ruleForm.allowrance1" size="mini">{{$t("healthIns1.food")}}</el-checkbox>
                    <el-checkbox v-model="ruleForm.allowrance2" size="mini">{{$t("healthIns1.housing")}}</el-checkbox>
                    <el-checkbox v-model="ruleForm.allowrance3" size="mini">{{$t("healthIns1.clothing")}}</el-checkbox>
                    <el-checkbox v-model="ruleForm.allowrance4" size="mini">{{$t("healthIns1.commuter_pass")}}
                    </el-checkbox>
                    <el-checkbox v-model="ruleForm.allowrance5" size="mini">{{$t("healthIns1.other")}}</el-checkbox>
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.other_allowrance" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns1.other')"
                      v-if="ruleForm.allowrance5 === true"></el-input>
                    <el-button class="el-icon-info" type="text" @click="otherAllowranceHint"
                      v-if="ruleForm.allowrance5 === true"></el-button>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="10">
                <div>
                  <el-form-item :label="$t('healthIns1.allowrance1st')" prop="allowrance_schedule1"
                    style="margin-left:50px">
                    <el-select v-model="ruleForm.allowrance_schedule1" :placeholder="$t('general.select')" size="mini"
                      style="margin-left:10px;width: 150px" clearable>
                      <el-option v-for="item in month" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns1.allowrance3rd')" prop="allowrance_schedule3"
                    style="margin-left:50px">
                    <el-select v-model="ruleForm.allowrance_schedule3" :placeholder="$t('general.select')" size="mini"
                      style="margin-left:10px;width: 150px" clearable>
                      <el-option v-for="item in month" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="10">
                <div>
                  <el-form-item :label="$t('healthIns1.allowrance2nd')" prop="allowrance_schedule2"
                    style="margin-left:50px">
                    <el-select v-model="ruleForm.allowrance_schedule2" :placeholder="$t('general.select')" size="mini"
                      style="margin-left:10px;width: 150px" clearable>
                      <el-option v-for="item in month" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns1.allowrance4th')" prop="allowrance_schedule4"
                    style="margin-left:50px">
                    <el-select v-model="ruleForm.allowrance_schedule4" :placeholder="$t('general.select')" size="mini"
                      style="margin-left:10px;width: 150px" clearable>
                      <el-option v-for="item in month" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>
          <el-collapse-item :title="$t('healthIns1.bonus')" name="3" style="margin-left:10px">
            <el-row>
              <el-col :span="10">
                <div>
                  <el-form-item :label="$t('healthIns1.first')" prop="bonus_schedule1" style="margin-left:50px">
                    <el-select v-model="ruleForm.bonus_schedule1" :placeholder="$t('general.select')" size="mini"
                      style="margin-left:10px;width: 150px" clearable>
                      <el-option v-for="item in month" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('healthIns1.third')" prop="bonus_schedule3" style="margin-left:50px">
                    <el-select v-model="ruleForm.bonus_schedule3" :placeholder="$t('general.select')" size="mini"
                      style="margin-left:10px;width: 150px" clearable>
                      <el-option v-for="item in month" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="10">
                <div>
                  <el-form-item :label="$t('healthIns1.second')" prop="bonus_schedule2" style="margin-left:50px">
                    <el-select v-model="ruleForm.bonus_schedule2" :placeholder="$t('general.select')" size="mini"
                      style="margin-left:10px;width: 150px" clearable>
                      <el-option v-for="item in month" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('healthIns1.fourth')" prop="bonus_schedule4" style="margin-left:50px">
                    <el-select v-model="ruleForm.bonus_schedule4" :placeholder="$t('general.select')" size="mini"
                      style="margin-left:10px;width: 150px" clearable>
                      <el-option v-for="item in month" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>
          <el-collapse-item :title="$t('healthIns1.agent')" name="4" style="margin-left:10px">
            <el-row>
              <el-col :span="10">
                <div>
                  <el-form-item :label="$t('healthIns1.agent')" style="margin-left:50px">
                    <el-select v-model="ruleForm.agent" :placeholder="$t('general.select')" size="mini"
                      style="margin-left:10px;width: 100px">
                      <el-option v-for="item in agent" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row v-if="ruleForm.agent === '有'">
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('healthIns1.agent_name')" prop="agent_name" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.agent_name" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns1.agent_name')"></el-input>
                    <el-button class="el-icon-info" type="text" @click="agentHint"></el-button>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('healthIns1.agent_address')" prop="agent_address" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.agent_address" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns1.agent_address')"></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>

          <el-collapse-item :title="$t('healthIns1.category')" name="5" style="margin-left:10px">
            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('healthIns1.category')" style="margin-left:50px">
                    <el-select v-model="ruleForm.div1" :placeholder="$t('general.select')" clearable size="mini"
                      style="margin-left:10px;width: 185px">
                      <el-option v-for="item in div1" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                    <el-button class="el-icon-info" type="text" @click="div1Hint" v-if="ruleForm.div1 === '個人'">
                    </el-button>
                  </el-form-item>
                  <el-form-item :label="$t('healthIns1.office_category')" v-if="ruleForm.div1 !== '個人'"
                    style="margin-left:50px">
                    <el-select v-model="ruleForm.div3" :placeholder="$t('general.select')" clearable size="mini"
                      style="margin-left:10px;width: 185px">
                      <el-option v-for="item in div3" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('healthIns1.no_category')" v-if="ruleForm.div1 !== '個人'"
                    style="margin-left:50px">
                    <el-select v-model="ruleForm.div2" :placeholder="$t('general.select')" clearable size="mini"
                      style="margin-left:10px;width: 185px">
                      <el-option v-for="item in div2" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns1.country_category')" v-if="ruleForm.div1 !== '個人'"
                    style="margin-left:50px">
                    <el-select v-model="ruleForm.div4" :placeholder="$t('general.select')" clearable size="mini"
                      style="margin-left:10px;width: 185px">
                      <el-option v-for="item in div4" :key="item.value" :label="item.label" :value="item.value"
                        style="margin-left:50px">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>
        </el-collapse>
        <el-row>
          <div>
            <br />
            <el-form-item :label="$t('healthIns1.remark')" prop="remark" style="margin-left:50px">
              <el-input prefix-icon="el-icon-edit" v-model="ruleForm.remark" size="mini"
                style="margin-left:10px;width: 300px" :placeholder="$t('healthIns1.remark')"></el-input>
            </el-form-item>
          </div>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button style="width:120px" @click="updateUser('ruleForm')" type="primary" size="medium">
          {{$t("general.confirm")}}
        </el-button>
        <el-button style="width:120px" @click="s1_cancel('ruleForm')" size="medium">{{$t("general.cancel")}}</el-button>
      </span>
    </el-dialog>

    <br />
    <div class="pages">
      <el-pagination background :disabled="disablePage" :current-page.sync="currentPage" small
        layout="prev, pager, next" :page-size="pageSize" :total="total" @current-change="handleCurrentChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        labelPosition: "left",
        value: [],
        ruleForm: {
          id: "",
          allowrance1: false,
          allowrance2: false,
          allowrance3: false,
          allowrance4: false,
          allowrance5: false,
          other_allowrance: "",
          allowrance_schedule1: "",
          allowrance_schedule2: "",
          allowrance_schedule3: "",
          allowrance_schedule4: "",
          bonus_schedule1: "",
          bonus_schedule2: "",
          bonus_schedule3: "",
          bonus_schedule4: "",
          agent: "無",
          agent_name: "",
          agent_address: "",
          healthInsName_kn: "",
          healthInsName: "",
          welfare_pension_no: "",
          welfare_pension_name: "",
          labor_ins_name: "",
          div1: "",
          div2: "",
          div3: "",
          div4: "",
          remark: "",

          name1: "",
          name2: "",
          name3: ""
        },
        rules: {},
        tableData: [],
        companyInfo: [],
        companyName: [],
        search: "",
        dialogVisible: false,
        dialogUpdate: false,
        pageSize: 6,
        currentPage: 1,
        total: 0,
        disablePage: false,
        allowrance: [{
            value: "食事",
            label: this.$t("healthIns1.food")
          },
          {
            value: "住宅",
            label: this.$t("healthIns1.housing")
          },
          {
            value: "被服",
            label: this.$t("healthIns1.clothing")
          },
          {
            value: "定期券",
            label: this.$t("healthIns1.commuter_pass")
          }
        ],
        agent: [{
            value: "無",
            label: this.$t("healthIns1.not_exist")
          },
          {
            value: "有",
            label: this.$t("healthIns1.exist")
          }
        ],
        div1: [{
            value: "法人",
            label: this.$t("healthIns1.corp")
          },
          {
            value: "個人",
            label: this.$t("healthIns1.individual")
          },
          {
            value: "国・地方公共団体",
            label: this.$t("healthIns1.national")
          }
        ],
        div2: [{
            value: "法人番号",
            label: this.$t("healthIns1.corp_no")
          },
          {
            value: "会社法人等番号",
            label: this.$t("healthIns1.company_no")
          }
        ],
        div3: [{
            value: "本店",
            label: this.$t("healthIns1.main_office")
          },
          {
            value: "支店",
            label: this.$t("healthIns1.branch_office")
          }
        ],
        div4: [{
            value: "内国法人",
            label: this.$t("healthIns1.domestic")
          },
          {
            value: "外国法人",
            label: this.$t("healthIns1.foreign")
          }
        ],
        month: [{
            value: "01",
            label: "01"
          },
          {
            value: "02",
            label: "02"
          },
          {
            value: "03",
            label: "03"
          },
          {
            value: "04",
            label: "04"
          },
          {
            value: "05",
            label: "05"
          },
          {
            value: "06",
            label: "06"
          },
          {
            value: "07",
            label: "07"
          },
          {
            value: "08",
            label: "08"
          },
          {
            value: "09",
            label: "09"
          },
          {
            value: "10",
            label: "10"
          },
          {
            value: "11",
            label: "11"
          },
          {
            value: "12",
            label: "12"
          }
        ]
      };
    },
    methods: {
      preview(index, row) {
        var uid = window.localStorage.getItem('LoginUserId');
        window.open("/pdf/健康保険・厚生年金保険事業所を設立-" + "uid=" + uid + ".pdf");
      },
      printPDF(index, row) {
        let postData = this.qs.stringify({
          id: row.id
        });
        this.axios({
            method: "post",
            url: "/healthIns1PDF",
            data: postData
          })
          .then(response => {
            this.handleCurrentChange();
            this.$message({
              type: "success",
              message: this.$t("general.print_completed")
            });
            setTimeout(() => {
              this.preview(index, row);
            }, 700);
            // console.log(response);
          })
          .catch(error => {
            this.$message({
              type: "warning",
              message: this.$t("general.print_failed")
            });
            console.log(error);
          });
      },
      otherAllowranceHint() {
        this.$notify.info({
          title: this.$t("healthIns1.otherHintTitle"),
          message: this.$t("healthIns1.otherHintMsg")
        });
      },
      agentHint() {
        this.$notify.info({
          title: this.$t("healthIns1.agentHintTitle"),
          message: this.$t("healthIns1.agentHintMsg")
        });
      },
      div1Hint() {
        this.$notify.info({
          title: this.$t("healthIns1.div1HintTitle"),
          message: this.$t("healthIns1.div1HintMsg")
        });
      },
      handleEdit(index, row) {
        this.dialogUpdate = true;
        this.ruleForm = Object.assign({}, row);
      },
      handleClose(done) {
        this.$confirm(this.$t("general.close_comfirm"), {
            cancelButtonClass: "btn-custom-cancel",
            confirmButtonClass: "btn-custom-confirm",
            confirmButtonText: this.$t("general.confirm"),
            cancelButtonText: this.$t("general.cancel"),
            type: "warning"
          })
          .then(_ => {
            this.emptyUserData();
            done();
          })
          .catch(_ => {});
      },
      handleDelete(index, row) {
        // console.log(index, row);
        this.$confirm(this.$t("general.sure_delete"), this.$t("general.hint"), {
            cancelButtonClass: "btn-custom-cancel",
            confirmButtonClass: "btn-custom-confirm",
            confirmButtonText: "OK",
            cancelButtonText: this.$t("general.cancel"),
            type: "warning"
          })
          .then(() => {
            let postData = this.qs.stringify({
              id: row.id
            });
            this.axios({
                method: "post",
                url: "/deleteHealthIns1",
                data: postData
              })
              .then(response => {
                this.getPages();
                this.currentPage = 1;
                this.axios
                  .post("/pageHealthIns1")
                  .then(response => {
                    this.tableData = response.data;
                  })
                  .catch(error => {
                    console.log(error);
                  });
                this.$message({
                  type: "success",
                  message: this.$t("general.delete_completed")
                });
                // console.log(response);
              })
              .catch(error => {
                console.log(error);
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: this.$t("general.canceled")
            });
          });
      },
      handleCurrentChange() {
        // console.log(`this.$t("general.current_page"): ${this.currentPage}`);
        let postData = this.qs.stringify({
          page: this.currentPage
        });
        this.axios({
            method: "post",
            url: "/pageHealthIns1",
            data: postData
          })
          .then(response => {
            this.tableData = response.data;
          })
          .catch(error => {
            console.log(error);
          });
      },
      s1_cancel(ruleForm) {
        this.dialogUpdate = false;
        this.dialogVisible = false;
        this.emptyUserData();
        this.$refs[ruleForm].resetFields();
      },
      cancel(ruleForm) {
        this.dialogUpdate = false;
        this.dialogVisible = false;
        this.emptyUserData();
      },
      emptyUserData() {
        this.ruleForm = {
          id: "",
          allowrance1: false,
          allowrance2: false,
          allowrance3: false,
          allowrance4: false,
          allowrance5: false,
          other_allowrance: "",
          allowrance_schedule1: "",
          allowrance_schedule2: "",
          allowrance_schedule3: "",
          allowrance_schedule4: "",
          bonus_schedule1: "",
          bonus_schedule2: "",
          bonus_schedule3: "",
          bonus_schedule4: "",
          agent: "無",
          agent_name: "",
          agent_address: "",
          healthInsName_kn: "",
          healthInsName: "",
          welfare_pension_no: "",
          welfare_pension_name: "",
          labor_ins_name: "",
          div1: "",
          div2: "",
          div3: "",
          div4: "",
          remark: "",
          name1: "",
          name2: "",
          name3: "",
        };
      },
      addUser(ruleForm) {
        this.$refs[ruleForm].validate((valid) => {
          if (valid) {
            let postData = this.qs.stringify({
              allowrance1: this.ruleForm.allowrance1,
              allowrance2: this.ruleForm.allowrance2,
              allowrance3: this.ruleForm.allowrance3,
              allowrance4: this.ruleForm.allowrance4,
              allowrance5: this.ruleForm.allowrance5,
              other_allowrance: this.ruleForm.other_allowrance,
              allowrance_schedule1: this.ruleForm.allowrance_schedule1,
              allowrance_schedule2: this.ruleForm.allowrance_schedule2,
              allowrance_schedule3: this.ruleForm.allowrance_schedule3,
              allowrance_schedule4: this.ruleForm.allowrance_schedule4,
              bonus_schedule1: this.ruleForm.bonus_schedule1,
              bonus_schedule2: this.ruleForm.bonus_schedule2,
              bonus_schedule3: this.ruleForm.bonus_schedule3,
              bonus_schedule4: this.ruleForm.bonus_schedule4,
              agent: this.ruleForm.agent,
              agent_name: this.ruleForm.agent_name,
              agent_address: this.ruleForm.agent_address,
              healthInsName_kn: this.ruleForm.healthInsName_kn,
              healthInsName: this.ruleForm.healthInsName,
              welfare_pension_no: this.ruleForm.welfare_pension_no,
              welfare_pension_name: this.ruleForm.welfare_pension_name,
              labor_ins_name: this.ruleForm.labor_ins_name,
              div1: this.ruleForm.div1,
              div2: this.ruleForm.div2,
              div3: this.ruleForm.div3,
              div4: this.ruleForm.div4,
              remark: this.ruleForm.remark
            });
            this.axios({
                method: "post",
                url: "/insertHealthIns1",
                data: postData
              })
              .then(response => {
                this.axios
                  .post("/pageHealthIns1")
                  .then(response => {
                    this.tableData = response.data;
                    this.currentPage = 1;
                    this.$message({
                      type: "success",
                      message: this.$t("general.add_completed")
                    });
                  })
                  .catch(error => {
                    this.$message({
                      type: "warning",
                      message: this.$t("general.add_failed")
                    });
                    console.log(error);
                  });
                this.getPages();
                this.dialogVisible = false;
                // console.log(response);
              })
              .catch(error => {
                console.log(error);
              });
          } else {
            console.log("error submit!!");
            this.$message({
              type: "error",
              message: this.$t("general.valid_failed")
            });
            return false;
          }
        });
      },
      updateUser(ruleForm) {
        this.$refs[ruleForm].validate((valid) => {
          if (valid) {
            let postData = this.qs.stringify({
              id: this.ruleForm.id,
              allowrance1: this.ruleForm.allowrance1,
              allowrance2: this.ruleForm.allowrance2,
              allowrance3: this.ruleForm.allowrance3,
              allowrance4: this.ruleForm.allowrance4,
              allowrance5: this.ruleForm.allowrance5,
              other_allowrance: this.ruleForm.other_allowrance,
              allowrance_schedule1: this.ruleForm.allowrance_schedule1,
              allowrance_schedule2: this.ruleForm.allowrance_schedule2,
              allowrance_schedule3: this.ruleForm.allowrance_schedule3,
              allowrance_schedule4: this.ruleForm.allowrance_schedule4,
              bonus_schedule1: this.ruleForm.bonus_schedule1,
              bonus_schedule2: this.ruleForm.bonus_schedule2,
              bonus_schedule3: this.ruleForm.bonus_schedule3,
              bonus_schedule4: this.ruleForm.bonus_schedule4,
              agent: this.ruleForm.agent,
              agent_name: this.ruleForm.agent_name,
              agent_address: this.ruleForm.agent_address,
              healthInsName_kn: this.ruleForm.healthInsName_kn,
              healthInsName: this.ruleForm.healthInsName,
              welfare_pension_no: this.ruleForm.welfare_pension_no,
              welfare_pension_name: this.ruleForm.welfare_pension_name,
              labor_ins_name: this.ruleForm.labor_ins_name,
              div1: this.ruleForm.div1,
              div2: this.ruleForm.div2,
              div3: this.ruleForm.div3,
              div4: this.ruleForm.div4,
              remark: this.ruleForm.remark
            });
            this.axios({
                method: "post",
                url: "/updateHealthIns1",
                data: postData
              })
              .then(response => {
                this.handleCurrentChange();
                this.s1_cancel(ruleForm);
                this.$message({
                  type: "success",
                  message: this.$t("general.edit_completed")
                });
                // console.log(response);
              })
              .catch(error => {
                this.$message({
                  type: "warning",
                  message: this.$t("general.edit_failed")
                });
                console.log(error);
              });
          } else {
            console.log("error submit!!");
            this.$message({
              type: "error",
              message: this.$t("general.valid_failed")
            });
            return false;
          }
        });
      },
      getPages() {
        this.axios
          .post("/rowsHealthIns1")
          .then(response => {
            this.total = response.data;
          })
          .catch(error => {
            console.log(error);
          });
      },
      refreshData() {
        location.reload();
      }
    },

    created() {
      this.axios
        .post("/pageHealthIns1")
        .then(response => {
          // console.log(response.data);
          this.show = true;
          this.tableData = response.data;
        })
        .catch(error => {
          this.show = false;
          this.$message({
            type: 'error',
            message: '開発中です。'
          });
          console.log(error);
        });

      this.axios
        .post("/rowsHealthIns1")
        .then(response => {
          this.total = response.data;
        })
        .catch(error => {
          console.log(error);
        });

      this.axios
        .post("/ListComInfo")
        .then((response) => {
          // console.log(response.data);
          this.companyInfo = response.data;
          // console.log(this.companyInfo);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };
</script>


<style>
  .btn-custom-cancel {
    float: right;
    margin-left: 10px;
    width: 90px;
  }

  .btn-custom-confirm {
    width: 90px;
  }
</style>
<style scoped>
  .search_name {
    width: 200px;
  }

  .pages {
    margin: 0px;
    padding: 0px;
    text-align: right;
  }

  .style1 {
    margin-right: 145px;
    padding: 0px;
    text-align: right;
  }
</style>


// WEBPACK FOOTER //
// src/components/HealthIns/HealthIns1.vue